import { HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { LoadingService } from 'src/app/shared/services/utils/loading.service';

export const loadingHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  loadingService.isLoading.next(true);

  return next(req).pipe(
    tap({
      next: (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          loadingService.isLoading.next(false);
        }
      },
      error: () => {
        loadingService.isLoading.next(false);
      }
    })
  );
};
